import { EmptyState, Skeleton } from '@/components';
import { usePollIdBySlug } from '@/features/polls/hooks';
import { Navigate, useParams } from '@solidjs/router';
import { Show } from 'solid-js';

/** `/to-polls/:slug` — the readable share link; resolves to the poll's page. */
export default function PollShortLink() {
  const params = useParams<{ slug: string }>();
  const query = usePollIdBySlug(() => params.slug);
  return (
    <Show when={!query.isPending} fallback={<Skeleton class="m-6 h-64" />}>
      <Show
        when={query.data?.data.id}
        fallback={<EmptyState variant="error" title="Poll not found" />}
      >
        {(id) => <Navigate href={`/polls/${id()}`} />}
      </Show>
    </Show>
  );
}
